//
// Copyright 2022 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/mesh/teleport/admission-discovery.proto (package dxos.mesh.teleport, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Credential } from "../../halo/credentials_pb.js";
import { file_dxos_halo_credentials } from "../../halo/credentials_pb.js";
import type { PublicKey } from "../../keys_pb.js";
import { file_dxos_keys } from "../../keys_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/mesh/teleport/admission-discovery.proto.
 */
export const file_dxos_mesh_teleport_admission_discovery: GenFile = /*@__PURE__*/
  fileDesc("CixkeG9zL21lc2gvdGVsZXBvcnQvYWRtaXNzaW9uLWRpc2NvdmVyeS5wcm90bxISZHhvcy5tZXNoLnRlbGVwb3J0InIKHUdldEFkbWlzc2lvbkNyZWRlbnRpYWxSZXF1ZXN0EicKCXNwYWNlX2tleRgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSKAoKbWVtYmVyX2tleRgCIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkiYQoeR2V0QWRtaXNzaW9uQ3JlZGVudGlhbFJlc3BvbnNlEj8KFGFkbWlzc2lvbl9jcmVkZW50aWFsGAEgASgLMiEuZHhvcy5oYWxvLmNyZWRlbnRpYWxzLkNyZWRlbnRpYWwynAEKGUFkbWlzc2lvbkRpc2NvdmVyeVNlcnZpY2USfwoWR2V0QWRtaXNzaW9uQ3JlZGVudGlhbBIxLmR4b3MubWVzaC50ZWxlcG9ydC5HZXRBZG1pc3Npb25DcmVkZW50aWFsUmVxdWVzdBoyLmR4b3MubWVzaC50ZWxlcG9ydC5HZXRBZG1pc3Npb25DcmVkZW50aWFsUmVzcG9uc2ViBnByb3RvMw", [file_dxos_halo_credentials, file_dxos_keys]);

/**
 * @generated from message dxos.mesh.teleport.GetAdmissionCredentialRequest
 */
export type GetAdmissionCredentialRequest = Message<"dxos.mesh.teleport.GetAdmissionCredentialRequest"> & {
  /**
   * @generated from field: dxos.keys.PublicKey space_key = 1;
   */
  spaceKey?: PublicKey;

  /**
   * @generated from field: dxos.keys.PublicKey member_key = 2;
   */
  memberKey?: PublicKey;
};

/**
 * Describes the message dxos.mesh.teleport.GetAdmissionCredentialRequest.
 * Use `create(GetAdmissionCredentialRequestSchema)` to create a new message.
 */
export const GetAdmissionCredentialRequestSchema: GenMessage<GetAdmissionCredentialRequest> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_teleport_admission_discovery, 0);

/**
 * @generated from message dxos.mesh.teleport.GetAdmissionCredentialResponse
 */
export type GetAdmissionCredentialResponse = Message<"dxos.mesh.teleport.GetAdmissionCredentialResponse"> & {
  /**
   * @generated from field: dxos.halo.credentials.Credential admission_credential = 1;
   */
  admissionCredential?: Credential;
};

/**
 * Describes the message dxos.mesh.teleport.GetAdmissionCredentialResponse.
 * Use `create(GetAdmissionCredentialResponseSchema)` to create a new message.
 */
export const GetAdmissionCredentialResponseSchema: GenMessage<GetAdmissionCredentialResponse> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_teleport_admission_discovery, 1);

/**
 * @generated from service dxos.mesh.teleport.AdmissionDiscoveryService
 */
export const AdmissionDiscoveryService: GenService<{
  /**
   * @generated from rpc dxos.mesh.teleport.AdmissionDiscoveryService.GetAdmissionCredential
   */
  getAdmissionCredential: {
    methodKind: "unary";
    input: typeof GetAdmissionCredentialRequestSchema;
    output: typeof GetAdmissionCredentialResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dxos_mesh_teleport_admission_discovery, 0);

